import { render, staticRenderFns } from "./ModalColumns.vue?vue&type=template&id=82465cfe&scoped=true&"
import script from "./ModalColumns.vue?vue&type=script&lang=js&"
export * from "./ModalColumns.vue?vue&type=script&lang=js&"
import style0 from "./ModalColumns.vue?vue&type=style&index=0&id=82465cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82465cfe",
  null
  
)

export default component.exports